import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";

import {
  Acceptable,
  AccountSettings,
  AuthenticatorScreen,
  BusinessClientStories,
  DeleteAccount,
  DriverContract,
  ForgotPassword,
  HelpCenter,
  LogoutPage,
  MoreWaysUse,
  OutAreaPolicy,
  PrivacyPolicy,
  PromoTerms,
  RefundCancel,
  Reports,
  ResetPassword,
  TermsUse,
} from "../pages";
import ReportAction from "../pages/reports/ReportAction";
import { AcceptedCategories } from "../pages/acceptedCategories/AcceptedCategories";
import { EditCategory } from "../pages/acceptedCategories/EditCategoryPage";
import { WebsiteBanner } from "../pages/websiteBanner/WebsiteBanner";
import PublicRoute from "./PublicRoute";
import LoginPage from "../pages/auth/LoginPage";
import { Notfound } from "./NewRouter";
import { MainLayout } from "../components/layout/MainLayout";
const Dashboard = lazy(() => import("../pages/home/Dashboard"));
const Orders = lazy(() => import("../pages/orders/Orders"));
const Clients = lazy(() => import("../pages/clients/Clients"));
const Drivers = lazy(() => import("../pages/drivers/Drivers"));
const DriverDetail = lazy(() => import("../pages/drivers/DriverDetail"));
const NewStatements = lazy(() => import("../pages/statements/NewStatements"));
const NewPayments = lazy(() => import("../pages/payments/NewPayments"));
const Calendar = lazy(() => import("../pages/calendar/Calendar"));
const Chats = lazy(() => import("../pages/chats/Chats"));
const RegularOffers = lazy(() =>
  import("../pages/regularOffers/RegularOffers")
);
const CreateRegularOffer = lazy(() =>
  import("../pages/regularOffers/CreateRegularOffer")
);
const HelpOffers = lazy(() => import("../pages/helpOffers/HelpOffers"));
const CreateHelpOffer = lazy(() =>
  import("../pages/helpOffers/CreateHelpOffer")
);
const Tutorials = lazy(() => import("../pages/tutorials/Tutorials"));
const CreateTutorials = lazy(() =>
  import("../pages/tutorials/CreateTutorials")
);
const Reviews = lazy(() => import("../pages/reviews/Reviews"));
const ChatDetails = lazy(() => import("../pages/chats/ChatDetails"));
const OrderDetail = lazy(() => import("../pages/orders/OrderDetail"));
const PickUpDetails = lazy(() => import("../pages/orders/PickUpDetails"));
const DropOffDetails = lazy(() => import("../pages/orders/DropOffDetails"));
const ClientDetail = lazy(() => import("../pages/clients/ClientDetail"));

const routes = [
  {
    path: "/",
    element: <Navigate to="dashboard" />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <MainLayout />,
        children: [
          {
            path: "dashboard",
            element: <Dashboard />,
          },
          {
            path: "services/orders",
            element: <Orders />,
          },
          { path: "order-detail", element: <OrderDetail /> },
          { path: "order-detail/pickup-details", element: <PickUpDetails /> },
          { path: "order-detail/dropoff-details", element: <DropOffDetails /> },
          {
            path: "services/reports",
            element: <Reports />,
          },
          {
            path: "services/clients",
            element: <Clients />,
          },
          { path: "client-detail", element: <ClientDetail /> },
          {
            path: "services/drivers",
            element: <Drivers />,
          },
          {
            path: "driver-detail",
            element: <DriverDetail />,
          },
          { path: "services/calendar", element: <Calendar /> },
          { path: "services/chats", element: <Chats /> },
          { path: "chats/chat-detail/:sessionID", element: <ChatDetails /> },
          {
            path: "services/reports/reportaction",
            element: <ReportAction />,
          },
          {
            path: "others/statements",
            element: <NewStatements />,
          },
          {
            path: "others/payments",
            element: <NewPayments />,
          },
          {
            path: "services/regular-offers",
            element: <RegularOffers />,
          },
          {
            path: "services/regular-offers/add",
            element: <CreateRegularOffer />,
          },
          {
            path: "services/help-offers",
            element: <HelpOffers />,
          },
          { path: "services/help-offers/add", element: <CreateHelpOffer /> },
          {
            path: "services/tutorials",
            element: <Tutorials />,
          },
          {
            path: "services/tutorials/add",
            element: <CreateTutorials />,
          },
          { path: "services/reviews", element: <Reviews /> },
          {
            path: "services/business-client",
            element: <BusinessClientStories />,
          },
          {
            path: "services/more-ways",
            element: <MoreWaysUse />,
          },
          {
            path: "others/account-settings",
            element: <AccountSettings />,
          },
          {
            path: "others/accepted-categories",
            element: <AcceptedCategories />,
          },
          {
            path: "others/accepted-categories/edit",
            element: <EditCategory />,
          },
          {
            path: "others/website-banner",
            element: <WebsiteBanner />,
          },
          {
            path: "others/help-center",
            element: <HelpCenter />,
          },
          {
            path: "others/delete-account",
            element: <DeleteAccount />,
          },
          {
            path: "others/logout",
            element: <LogoutPage />,
          },
          {
            path: "legals/privacy-policy",
            element: <PrivacyPolicy />,
          },
          {
            path: "legals/terms-of-use",
            element: <TermsUse />,
          },
          {
            path: "legals/promo-terms",
            element: <PromoTerms />,
          },
          {
            path: "legals/refund-cancel",
            element: <RefundCancel />,
          },
          { path: "legals/acceptable-item", element: <Acceptable /> },
          { path: "legals/out-area-policy", element: <OutAreaPolicy /> },
          { path: "legals/driver-contract", element: <DriverContract /> },
        ],
      },
    ],
  },

  {
    element: <PublicRoute />,
    children: [
      {
        path: "/login",
        element: <LoginPage />,
      },
      {
        path: "authenticator",
        element: <AuthenticatorScreen />,
      },
      {
        path: "forgot-password",
        element: <ForgotPassword />,
      },
      {
        path: "reset-password",
        element: <ResetPassword />,
      },
    ],
  },
  {
    path: "*",
    element: <Notfound />,
  },
];

export default routes;
